import { LookerProvider } from 'context/LookerContext';

import { DashboardProvider } from './context/DashboardContext';
import { DashboardSectionsLayout } from './DashboardSectionsLayout';

export const DashboardLayout = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  return (
    <LookerProvider>
      <DashboardProvider>
        <DashboardSectionsLayout currentSectionIndex={currentSectionIndex} />
      </DashboardProvider>
    </LookerProvider>
  );
};
